import React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { NFT_DESCRIPTION, NFT_NAME } from "../libs/constants";
import { copyText, shortenAddress } from "../libs/utils";
import NftActionMenu from "./NFTActionMenu";
import { NftInterface } from "./types";

interface NftCardBoxProps {
  nft: NftInterface;
}

export default function NftCardBox({ nft }: NftCardBoxProps) {
  return (
    <Card>
      <CardHeader
        action={<NftActionMenu nft={nft} />}
        title={NFT_NAME}
        subheader={`${nft.investedAmount} USDC`}
      />
      <CardMedia
        component="img"
        image="./assets/nft-image.png"
        alt="NFT Image"
      />
      <CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              width: "100%",
            }}
          >
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              NFT ID:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Link
                href={`https://solscan.io/token/${nft.id}?cluster=devnet`}
                target="_blank"
                sx={{ color: "text.secondary" }}
              >
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {shortenAddress(nft.id, 4)}
                </Typography>
              </Link>
              <IconButton onClick={() => copyText(nft.id)} size="small" sx={{}}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              width: "100%",
            }}
          >
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Signup Address:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {shortenAddress(nft.signupAddress, 4)}
              </Typography>
              <IconButton
                onClick={() => copyText(nft.signupAddress)}
                size="small"
                sx={{}}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              width: "100%",
            }}
          >
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Sign Link:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Link
                href={`/?a=${nft.signupAddress}`}
                target="_blank"
                sx={{ color: "text.secondary" }}
              >
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  https://.../?a=
                  {shortenAddress(`${nft.signupAddress}`, 3)}
                </Typography>
              </Link>
              <IconButton
                onClick={() =>
                  copyText(
                    `https://app.smartypants.exchange/?a=${nft.signupAddress}`
                  )
                }
                size="small"
                sx={{}}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
